export default "__VITE_ASSET__N4Fr0hQC__"